module.exports = __webpack_public_path__ + "img/motorbike.a44b20ec.svg";